import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

function UpgradeLimitModal({ open, onClose }) {
  const navigate = useNavigate();
  const primaryButtonRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const previouslyFocusedElement = document.activeElement;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    primaryButtonRef.current?.focus();

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      previouslyFocusedElement?.focus?.();
    };
  }, [open, onClose]);

  if (!open) return null;

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) onClose();
  };

  const handleUpgrade = () => {
    onClose();
    navigate("/pro");
  };

  return (
    <div style={overlayStyle} role="presentation" onClick={handleBackdropClick}>
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="upgrade-title"
        aria-describedby="upgrade-description"
        style={modalStyle}
      >
        <h2 id="upgrade-title">You’ve reached the Free plan limit.</h2>
        <p id="upgrade-description" style={copyStyle}>
          Go Pro to create unlimited builds.
        </p>
        <button
          ref={primaryButtonRef}
          type="button"
          onClick={handleUpgrade}
          style={primaryStyle}
        >
          Go Pro
        </button>
        <button type="button" onClick={onClose} style={secondaryStyle}>
          Maybe Later
        </button>
      </section>
    </div>
  );
}

const overlayStyle = { position: "fixed", inset: 0, zIndex: 20000, display: "grid", placeItems: "center", padding: "20px", background: "rgba(0,0,0,.78)" };
const modalStyle = { width: "min(100%, 420px)", boxSizing: "border-box", padding: "26px", border: "1px solid #333", borderRadius: "20px", background: "#181818", color: "white", textAlign: "center" };
const copyStyle = { color: "#bbb", lineHeight: 1.6 };
const primaryStyle = { width: "100%", minHeight: "48px", border: 0, borderRadius: "12px", background: "#e10600", color: "white", fontWeight: 800, cursor: "pointer" };
const secondaryStyle = { ...primaryStyle, marginTop: "10px", background: "#303030" };

export default UpgradeLimitModal;
